import * as React from 'react';

interface IProps {
    className?: string;
}

class HamburgerIcon extends React.Component<IProps> {
    public render() {
        return (
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={this.props.className}>
                <path d="M26 9H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M26 23H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M26 16H6" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
        );
    }
}

export default HamburgerIcon;
